"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

require("./Notifications.css");

var utils = _interopRequireWildcard(require("../../shared"));

var _Illustration = _interopRequireDefault(require("../Illustration/Illustration"));

var _NotificationsItem = _interopRequireDefault(require("./NotificationsItem"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/*
Component to display list of notifications
and empty message if there are no notifications to display
*/
function Notifications(_ref) {
  var children = _ref.children,
      emptyTitle = _ref.emptyTitle,
      emptyMessage = _ref.emptyMessage,
      size = _ref.size,
      className = _ref.className,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["children", "emptyTitle", "emptyMessage", "size", "className"]);

  var cssClasses = [];

  if (_react["default"].Children.count(children) === 0) {
    cssClasses = ['st_notifications__empty', "st_notifications__empty--" + size];
    cssClasses = utils.classNames.addClassNames(className, cssClasses);
    return /*#__PURE__*/_react["default"].createElement("div", _extends({
      className: cssClasses.join(' ')
    }, otherProps), /*#__PURE__*/_react["default"].createElement(_Illustration["default"], {
      name: "no-notifications",
      className: "st_notifications__emptyimg"
    }), emptyTitle && /*#__PURE__*/_react["default"].createElement("h3", {
      className: "st_notifications__emptytitle"
    }, emptyTitle), emptyMessage && /*#__PURE__*/_react["default"].createElement("p", {
      className: "st_notifications__emptytext"
    }, emptyMessage));
  }

  cssClasses = utils.classNames.addClassNames(className, ['st_notifications']);
  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: cssClasses.join(' ')
  }, otherProps), children);
} // proptypes definitions


Notifications.propTypes = {
  /** message to display if there are no notifications */
  emptyMessage: _propTypes["default"].string,

  /** title to display if there are no notifications */
  emptyTitle: _propTypes["default"].string,

  /** size of notifications */
  size: _propTypes["default"].oneOf(['md', 'lg']),

  /** any extra CSS classes */
  className: utils.classNames.classNameProps
}; // default props

Notifications.defaultProps = {
  emptyMessage: null,
  emptyTitle: null,
  size: 'md',
  className: null
};
Notifications.Item = _NotificationsItem["default"];
var _default = Notifications;
exports["default"] = _default;